<template>
  <div>
    <!-- toolbar -->
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ changeHeaderTitle }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn class="primary" @click="BackToRoles">{{
        $t("buttons.rolesBack")
      }}</v-btn>
    </v-toolbar>

    <v-form @submit.prevent="saveRoles">
      <!-- <v-container> -->
      <v-layout class="bg-white pa-3 mb-3" row wrap>
        <v-flex xs12 class="px-2">
          <form-group :validator="$v.name" attribute="name" name="role">
            <template slot-scope="{ attrs }">
              <v-text-field
                v-bind="attrs"
                v-model="name"
                label="Name"
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
                @keypress="holdUpdate"
                @change="holdUpdate"
              ></v-text-field>
            </template>
          </form-group>
        </v-flex>
        <v-flex xs12 class="px-2">
          <form-group
            :validator="$v.descreption"
            attribute="descreption"
            name="description"
          >
            <template slot-scope="{ attrs }">
              <v-textarea
                label="Description"
                v-bind="attrs"
                value
                rows="15"
                v-model="descreption"
                @input="$v.descreption.$touch()"
                @blur="$v.descreption.$touch()"
                @keypress="holdUpdate"
                @change="holdUpdate"
              ></v-textarea>
            </template>
          </form-group>
        </v-flex>
        <v-flex xs12 class="px-2 my-3">
          <v-btn
            :disabled="$v.$invalid || update"
            :loading="loading"
            type="submit"
            large
            color="success"
            class="ma-0"
            >{{ changeTitle }}</v-btn
          >
        </v-flex>
      </v-layout>
      <!-- </v-container> -->
    </v-form>
    <!-- toolbar -->

    <!-- table -->
    <v-data-table
      v-model="selected"
      item-key="name"
      :headers="headers"
      :items="permissons"
      hide-default-footer
      :mobile-breakpoint="zero"
      disable-pagination
      show-select
    >
      <template v-slot:headers="props">
        <tr>
          <th class="text-center toggle-spacing">
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.stop="toggleAll(props)"
            ></v-checkbox>
          </th>
          <th
            class="text-center"
            v-for="header in props.headers"
            :key="header.text"
          >
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:item="props">
        <tr :active="props.selected">
          <td class="toggle-spacing">
            <v-checkbox
              @change="hadnleSelect(props)"
              :input-value="props.item.checked"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td class="text-center">{{ props.item.name }}</td>

          <td
            class="box py-3 toggle-spacing"
            v-for="permisson in props.item.value"
            :key="permisson.id"
          >
            <v-checkbox
              @change="holdUpdate(props.item)"
              :value="permisson.id"
              v-model="selectedBox"
              hide-details
              color="red"
            ></v-checkbox>
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- table -->
  </div>
</template>

<script>
import { createRole, showRole, updateRole } from "@/api/roles.js";
import { IndexPermemissions } from "@/api/permissions.js";

import { required, maxLength, minLength } from "vuelidate/lib/validators";
const customValue = param => value => {
  console.log(param);
  const SplitedWords = value.split(" ");
  if (SplitedWords.length > param) {
    return false;
  } else {
    return true;
  }
};
export default {
  validations: {
    name: {
      required,
      maxLength: maxLength(30),
      minLength: minLength(3)
    },
    descreption: { required, customValue: customValue(500) }
  },
  data() {
    return {
      // valid: true,
      testSlected: true,
      checkbox: false,
      selectedBox: !this.edit ? [] : this.updateSelect,
      selected: [],
      permissons: [],
      name: "",
      descreption: "",
      headers: [
        {
          key: "permissons ",
          align: "center",
          sortable: false,
          value: "Permissons"
        },
        { key: "index", sortable: false, align: "center" },
        { key: "show", sortable: false, align: "center" },
        { key: "store", sortable: false, align: "center" },
        { key: "update", sortable: false, align: "center" },
        { key: "destroy", sortable: false, align: "center" }
      ],
      editPermission: [],
      edit: false,
      update: true,
      loading: false,
      defaultIds: [],
      zero: 0
    };
  },
  mounted() {
    this.translateTableHeader(this.headers);
    if (this.$route.query.id) {
      this.edit = true;

      showRole(this.$route.query.id)
        .then(res => {
          // console.log(res.data.role);
          this.editPermission = res.data.role;

          this.name = this.editPermission.display_name;
          this.descreption = this.editPermission.description;
          const newSelceted = this.editPermission.permissions.map(el => el.id);
          this.defaultIds = newSelceted;
          this.selectedBox = newSelceted;
          // this.selected = newSelceted;
          this.checkbox = true;
        })
        .catch(err => console.log(err));
    } else {
      this.edit = false;
    }
  },
  created() {
    IndexPermemissions()
      .then(res => {
        const { data } = res.data;
        // convert object to array
        const convertedData = Object.keys(data).map(function(key) {
          return {
            name: key,
            value: data[key],
            checked: false
          };
        });
        this.permissons = convertedData;
      })
      .catch(err => console.log(err));
  },

  computed: {
    changeTitle() {
      return this.edit ? this.$t("buttons.edit") : this.$t("buttons.create");
    },
    changeHeaderTitle() {
      return this.edit ? this.$t("headings.edit") : this.$t("headings.create");
    }
  },
  methods: {
    hadnleSelect(props) {
      props.selected = !props.selected;
      props.item.checked = !props.item.checked;
      const { item } = props;

      const { checked } = item;
      item.value.map(el => {
        if (checked) {
          this.selectedBox.push(el.id);
        } else {
          this.selectedBox = this.selectedBox.filter(id => id !== el.id);
        }
      });
      this.update = false;
    },
    toggleAll({ all }) {
      console.log(all);
      if (this.selected.length) this.selected = [];
      else this.selected = this.permissons.slice();
      this.$nextTick(() => {
        if (!all) {
          this.selectedBox = this.selected
            .map(el => el.value.map(val => val.id))
            .flatMap(el => el);
          // this.permissons.map(el => (el.checked = !el.checked));
        } else {
          this.selectedBox = [];
          // this.permissons.map(el => (el.checked = !el.checked));
        }
        if (!all) {
          this.permissons.map(el => {
            el.checked = true;
          });
        } else {
          this.permissons.map(el => {
            el.checked = false;
          });
        }
      });
    },
    saveRoles() {
      this.loading = true;
      this.$v.$touch();
      if (!this.edit) {
        // in case create roles
        if (this.selectedBox.length > 0 && this.name && this.descreption) {
          const createdData = {
            name: this.name,
            display_name: this.name,
            description: this.descreption,
            permissions_ids: this.selectedBox,
            locale: "en"
          };
          createRole(createdData)
            .then(() => {
              this.loading = false;
              this.$v.$reset();
              this.name = "";
              this.descreption = "";
              this.selectedBox = [];
              this.update = !this.update;
              this.$router.push("/roles/list");
            })
            .catch(err => {
              console.log(err.response);
              this.loading = false;
            })
            .finally(() => {
              this.$router.push("/roles/list");
            });
        }
      } else {
        const updateData = {
          name: this.name,
          display_name: this.name,
          description: this.descreption,
          permissions_ids: this.selectedBox,
          locale: "en"
        };
        updateRole(updateData, this.$route.query.id)
          .then(res => {
            console.log(res);
            this.loading = false;
            const { newUpdateData } = res.data;
            this.editPermission = newUpdateData;
            this.update = !this.update;
            this.$router.push("/roles/list");
          })
          .catch(err => console.log(err));
      }
    },
    holdUpdate(permisson) {
      // const { checked } = permisson;
      const ids = [];
      const editIds = [];
      permisson.value.map(el => {
        ids.push(el.id);
        this.selectedBox.filter(id => {
          if (el.id === id) {
            editIds.push(el.id);
          }
        });
      });
      if (editIds.length === ids.length) {
        permisson.checked = true;
      } else {
        permisson.checked = false;
      }

      if (this.edit) {
        this.update = false;
        this.checkbox = false;
      } else {
        if (this.selectedBox.length === 0) {
          this.checkbox = true;
          this.update = true;
        } else {
          this.update = false;
        }
      }
    },
    BackToRoles() {
      this.$router.push("/roles");
    }
  },
  watch: {
    "$route.query.id": function() {
      this.edit = false;
      this.checkbox = false;
      this.name = "";
      this.descreption = "";
      this.selectedBox = [];

      this.$v.$reset();
    },
    permissons: {
      handler(permissons) {
        if (permissons.length || this.editPermission) {
          // console.log(permissons);
          permissons.map(per =>
            per.value.map(el => {
              this.editPermission.permissions.map(value => {
                if (el.id == value.id) {
                  per.checked = true;
                }
              });
            })
          );
        }
      },
      immediate: true
    }
  }
};
</script>
